// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ActionsButton-module__font-s-10___IA9eJ {
  font-size: 10px !important;
}

.ActionsButton-module__font-s-12___Y_6K3 {
  font-size: 12px !important;
}

.ActionsButton-module__font-s-13___xCJCc {
  font-size: 13px !important;
}

.ActionsButton-module__font-s-14___wlM8E {
  font-size: 14px !important;
}

.ActionsButton-module__font-s-15___BPvvq {
  font-size: 15px !important;
}

.ActionsButton-module__font-s-16___gdMWH {
  font-size: 16px !important;
}

.ActionsButton-module__font-s-18___hHdZu {
  font-size: 18px !important;
}

.ActionsButton-module__font-s-20___OLEZs {
  font-size: 20px !important;
}

.ActionsButton-module__font-s-22___e05Ix {
  font-size: 22px !important;
}

.ActionsButton-module__font-s-28___peiDT {
  font-size: 28px !important;
}

.ActionsButton-module__font-w-400___xzi77 {
  font-weight: 400 !important;
}

.ActionsButton-module__font-w-500___UsCtb {
  font-weight: 500 !important;
}

.ActionsButton-module__font-w-600___rai7t {
  font-weight: 600 !important;
}

.ActionsButton-module__font-w-700___i2qhc {
  font-weight: 700 !important;
}

.ActionsButton-module__p-5___yVgam {
  padding: 5px !important;
}

.ActionsButton-module__p-12___BXqXG {
  padding: 12px !important;
}

.ActionsButton-module__p-16___z9jFQ {
  padding: 16px !important;
}

.ActionsButton-module__p-30___EpdwB {
  padding: 30px !important;
}

.ActionsButton-module__p-b-0___Wpros {
  padding-bottom: 0 !important;
}

.ActionsButton-module__p-b-5___Mt7hX {
  padding-bottom: 5px !important;
}

.ActionsButton-module__p-b-10___ikWsV {
  padding-bottom: 10px !important;
}

.ActionsButton-module__p-b-12___liaKa {
  padding-bottom: 12px !important;
}

.ActionsButton-module__p-b-16___KQhjc {
  padding-bottom: 16px !important;
}

.ActionsButton-module__p-b-18____OebH {
  padding-bottom: 18px !important;
}

.ActionsButton-module__p-b-20___BK9Sq {
  padding-bottom: 20px !important;
}

.ActionsButton-module__p-b-25___CxuTl {
  padding-bottom: 25px !important;
}

.ActionsButton-module__p-b-30___OzX00 {
  padding-bottom: 30px !important;
}

.ActionsButton-module__p-b-50___NT6jW {
  padding-bottom: 50px !important;
}

.ActionsButton-module__p-t-0___SVxHg {
  padding-top: 0 !important;
}

.ActionsButton-module__p-t-12___DojMc {
  padding-top: 12px !important;
}

.ActionsButton-module__p-t-16___nSwze {
  padding-top: 16px !important;
}

.ActionsButton-module__p-t-18___BD36c {
  padding-top: 18px !important;
}

.ActionsButton-module__p-t-20___c7lhA {
  padding-top: 20px !important;
}

.ActionsButton-module__p-t-30___OPGi7 {
  padding-top: 30px !important;
}

.ActionsButton-module__p-t-40___c1l41 {
  padding-top: 40px !important;
}

.ActionsButton-module__p-t-50___is_tv {
  padding-top: 50px !important;
}

.ActionsButton-module__p-l-20___nHYju {
  padding-left: 20px !important;
}

.ActionsButton-module__p-l-30___t3MHj {
  padding-left: 30px !important;
}

.ActionsButton-module__p-l-40___tWrxQ {
  padding-left: 40px !important;
}

.ActionsButton-module__p-r-16___Xa5Fy {
  padding-right: 16px !important;
}

.ActionsButton-module__p-r-20___bOcVS {
  padding-right: 20px !important;
}

.ActionsButton-module__p-r-30___Xde8r {
  padding-right: 30px !important;
}

.ActionsButton-module__p-r-50___xVCMu {
  padding-right: 50px !important;
}

.ActionsButton-module__p-r-60___qvdI0 {
  padding-right: 60px !important;
}

.ActionsButton-module__m-b-1___zSj5m {
  margin-bottom: 1px !important;
}

.ActionsButton-module__m-b-2___ek55G {
  margin-bottom: 2px !important;
}

.ActionsButton-module__m-b-6___JJsfc {
  margin-bottom: 6px !important;
}

.ActionsButton-module__m-b-8___ggZdM {
  margin-bottom: 8px !important;
}

.ActionsButton-module__m-b-10___mnzpT {
  margin-bottom: 10px !important;
}

.ActionsButton-module__m-b-14___NwR4M {
  margin-bottom: 14px !important;
}

.ActionsButton-module__m-b-16___bjs3_ {
  margin-bottom: 16px !important;
}

.ActionsButton-module__m-b-20___PwnRw {
  margin-bottom: 20px !important;
}

.ActionsButton-module__m-b-22___b_TPX {
  margin-bottom: 22px !important;
}

.ActionsButton-module__m-b-24___pgXDK {
  margin-bottom: 24px !important;
}

.ActionsButton-module__m-b-30___I4DU0 {
  margin-bottom: 30px !important;
}

.ActionsButton-module__m-b-32___fxMvU {
  margin-bottom: 32px !important;
}

.ActionsButton-module__m-b-40___nHwPt {
  margin-bottom: 40px !important;
}

.ActionsButton-module__m-t-2___TFEYU {
  margin-top: 2px !important;
}

.ActionsButton-module__m-t-3___TMYbb {
  margin-top: 3px !important;
}

.ActionsButton-module__m-t-4___FupYI {
  margin-top: 4px !important;
}

.ActionsButton-module__m-t-5___K9Ujq {
  margin-top: 5px !important;
}

.ActionsButton-module__m-t-8___GXTrv {
  margin-top: 8px !important;
}

.ActionsButton-module__m-t-10___TFexh {
  margin-top: 10px !important;
}

.ActionsButton-module__m-t-15___kzkGK {
  margin-top: 15px !important;
}

.ActionsButton-module__m-t-16___MrewF {
  margin-top: 16px !important;
}

.ActionsButton-module__m-t-20___XFISa {
  margin-top: 20px !important;
}

.ActionsButton-module__m-t-22___OqKEp {
  margin-top: 22px !important;
}

.ActionsButton-module__m-t-30___gWz0U {
  margin-top: 30px !important;
}

.ActionsButton-module__m-t-32___u11EV {
  margin-top: 32px !important;
}

.ActionsButton-module__m-l-auto___TsjAV {
  margin-left: auto !important;
}

.ActionsButton-module__m-l-4___WP0sd {
  margin-left: 4px !important;
}

.ActionsButton-module__m-l-5___vnN_F {
  margin-left: 5px !important;
}

.ActionsButton-module__m-l-6___Bz6HS {
  margin-left: 6px !important;
}

.ActionsButton-module__m-l-8___d2tp6 {
  margin-left: 8px !important;
}

.ActionsButton-module__m-l-10___G1xnR {
  margin-left: 10px !important;
}

.ActionsButton-module__m-l-16___JhC_t {
  margin-left: 16px !important;
}

.ActionsButton-module__m-l-20___ucw01 {
  margin-left: 20px !important;
}

.ActionsButton-module__m-l-24___Sm05S {
  margin-left: 24px !important;
}

.ActionsButton-module__m-l-30___wH4a9 {
  margin-left: 30px !important;
}

.ActionsButton-module__m-l-35___ncdHN {
  margin-left: 35px !important;
}

.ActionsButton-module__m-l-40___wbKxD {
  margin-left: 40px !important;
}

.ActionsButton-module__m-r-8___lhf4B {
  margin-right: 8px !important;
}

.ActionsButton-module__m-r-10___pQdS6 {
  margin-right: 10px !important;
}

.ActionsButton-module__m-r-16___IqIBa {
  margin-right: 16px !important;
}

.ActionsButton-module__m-r-20___evWhd {
  margin-right: 20px !important;
}

.ActionsButton-module__m-r-24___uvZtk {
  margin-right: 24px !important;
}

.ActionsButton-module__m-r-30___rspgd {
  margin-right: 30px !important;
}

.ActionsButton-module__m-r-40____0opc {
  margin-right: 40px !important;
}

.ActionsButton-module__border-r-3___GCPnC {
  border-radius: 3px !important;
}

.ActionsButton-module__border-r-4___leSze {
  border-radius: 4px !important;
}

.ActionsButton-module__border-r-6___tR8cE {
  border-radius: 6px !important;
}

.ActionsButton-module__border-r-10___mqRPD {
  border-radius: 10px !important;
}

.ActionsButton-module__border-r-12___h5BBg {
  border-radius: 12px !important;
}

.ActionsButton-module__border-r-16___CV5jL {
  border-radius: 16px !important;
}

.ActionsButton-module__border-r-50___qCstG {
  border-radius: 50% !important;
}

.ActionsButton-module__primary-border___U1zah {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.ActionsButton-module__primary-border-b___B43t8 {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.ActionsButton-module__primary-border-t___l10aq {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.ActionsButton-module__primary-border-l___LSTZY {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.ActionsButton-module__primary-border-r___kc0NF {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.ActionsButton-module__secondary-border___hXI0s {
  border: 1px solid #637768;
}

.ActionsButton-module__secondary-border-b___rgff3 {
  border-bottom: 1px solid #637768;
}

.ActionsButton-module__secondary-border-t___aJOW8 {
  border-top: 1px solid #637768;
}

.ActionsButton-module__secondary-border-l___YMK2N {
  border-left: 1px solid #637768;
}

.ActionsButton-module__secondary-border-r___CNQgb {
  border-right: 1px solid #637768;
}

.ActionsButton-module__gap-0___yax3x {
  gap: 0 !important;
}

.ActionsButton-module__gap-2___LLLyq {
  gap: 2px !important;
}

.ActionsButton-module__gap-4___r9DiI {
  gap: 4px !important;
}

.ActionsButton-module__gap-5___nt1Ku {
  gap: 5px !important;
}

.ActionsButton-module__gap-6___bSwTW {
  gap: 6px !important;
}

.ActionsButton-module__gap-8___eivzj {
  gap: 8px !important;
}

.ActionsButton-module__gap-10___V8v4D {
  gap: 10px !important;
}

.ActionsButton-module__gap-12___L6ZMS {
  gap: 12px !important;
}

.ActionsButton-module__gap-14___ceP4g {
  gap: 14px !important;
}

.ActionsButton-module__gap-16___eu7Yw {
  gap: 16px !important;
}

.ActionsButton-module__gap-18___rXyjx {
  gap: 18px !important;
}

.ActionsButton-module__gap-20___HQRHa {
  gap: 20px !important;
}

.ActionsButton-module__gap-24___Kfp4y {
  gap: 24px !important;
}

.ActionsButton-module__gap-26___HE_cO {
  gap: 26px !important;
}

.ActionsButton-module__gap-30___Venb_ {
  gap: 30px !important;
}

.ActionsButton-module__gap-32___S3xH_ {
  gap: 32px !important;
}

.ActionsButton-module__gap-40___uBI9u {
  gap: 40px !important;
}

.ActionsButton-module__gap-50___rICQQ {
  gap: 50px !important;
}

.ActionsButton-module__flex-1___n_k2I {
  flex: 1;
}

.ActionsButton-module__flex-none____GFVo {
  flex: none !important;
}

.ActionsButton-module__flex-column___Fh22G {
  display: flex;
  flex-direction: column !important;
}

.ActionsButton-module__flex-row___GYHgp {
  display: flex;
  flex-direction: row !important;
}

.ActionsButton-module__vertically-centered___eNbZ1 {
  display: flex;
  align-items: center !important;
}

.ActionsButton-module__horizontally-centered___wB7p3 {
  display: flex;
  justify-content: center !important;
}

.ActionsButton-module__horizontally-end___Bodt8 {
  display: flex;
  justify-content: end !important;
}

.ActionsButton-module__vertically-start___MEXii {
  display: flex;
  align-items: start !important;
}

.ActionsButton-module__space-between___XfzPT {
  display: flex;
  justify-content: space-between !important;
}

.ActionsButton-module__flex-wrap___LiasK {
  flex-wrap: wrap !important;
}

.ActionsButton-module__height-100___sZaeP {
  height: 100%;
}

.ActionsButton-module__width-50___PNWT0 {
  width: 50% !important;
}

.ActionsButton-module__width-100___X0SoN {
  width: 100%;
}

.ActionsButton-module__cursor-pointer___oBmyT {
  cursor: pointer;
}

.ActionsButton-module__cursor-not-allowed___yzT0S {
  cursor: not-allowed !important;
}

.ActionsButton-module__absolute-centered___G_1xD {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.ActionsButton-module__absolute___qB6dl {
  position: absolute;
}

.ActionsButton-module__relative___HLYFl {
  position: relative;
}

.ActionsButton-module__fixed___YLg2b {
  position: fixed;
}

.ActionsButton-module__visible___YUhyg {
  opacity: 1;
}

.ActionsButton-module__invisible___TnsM9 {
  opacity: 0;
}

.ActionsButton-module__col-90___rbJ1J {
  width: 90% !important;
}

.ActionsButton-module__col-auto___kmhJV {
  width: auto !important;
}

.ActionsButton-module__medical-tabs___eJ9I5 {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.ActionsButton-module__medical-table-new___xsRTo {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.ActionsButton-module__medical-table-new___xsRTo:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.ActionsButton-module__medical-table-new___xsRTo::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.ActionsButton-module__medical-table-new___xsRTo::-webkit-scrollbar-track {
  display: none;
}
.ActionsButton-module__medical-table-new___xsRTo.ActionsButton-module__no-pagination___jj6bR {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.ActionsButton-module__medical-table-new___xsRTo.ActionsButton-module__no-pagination___jj6bR:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.ActionsButton-module__medical-table-new___xsRTo.ActionsButton-module__no-pagination___jj6bR::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.ActionsButton-module__medical-table-new___xsRTo.ActionsButton-module__no-pagination___jj6bR::-webkit-scrollbar-track {
  display: none;
}

.ActionsButton-module__medical-table-empty___sx9jU {
  padding: 14px 40px !important;
}

.ActionsButton-module__icon-btn___VhtWl {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.ActionsButton-module__search-icon___jD7aP {
  width: 24px;
  height: 24px;
  align-self: center;
}

.ActionsButton-module__disable-select___CJrCi {
  user-select: none;
}

.ActionsButton-module__break-word___VvQL1 {
  word-break: break-word;
}

.ActionsButton-module__popup-clear-btn___GN1zr {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.ActionsButton-module__scroll-m-b-20___TTai9 {
  scroll-margin-bottom: 20px;
}

.ActionsButton-module__button___weqaq {
  padding: 5px 10px;
  margin-left: -14px;
  gap: 4px !important;
  justify-content: flex-start !important;
}
.ActionsButton-module__button___weqaq > img {
  width: 22px;
  height: 22px;
}
.ActionsButton-module__button___weqaq > span {
  font-size: 14px !important;
}

.ActionsButton-module__menu___uwy1l {
  width: 250px;
}
.ActionsButton-module__menu___uwy1l > * {
  color: #375844;
  font-size: 14px !important;
  font-weight: 500;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/components/buttons/ActionsButton/ActionsButton.module.scss","webpack://./../common/src/styles/global/_mixins.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,sCAAA;AA8pBF;AA5pBE;EACE,WAAA;EACA,YAAA;AA8pBJ;AA3pBE;EACE,0BAAA;AA6pBJ;;AAzpBA;EACE,YAAA;AA4pBF;AA1pBE;EACE,cAAA;EACA,0BAAA;EACA,gBAAA;AA4pBJ","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.button {\n  padding: 5px 10px;\n  margin-left: -14px;\n  gap: 4px !important;\n  justify-content: flex-start !important;\n\n  & > img {\n    width: 22px;\n    height: 22px;\n  }\n\n  & > span {\n    font-size: 14px !important;\n  }\n}\n\n.menu {\n  width: 250px;\n\n  & > * {\n    color: get-color(greenNew, dark);\n    font-size: 14px !important;\n    font-weight: 500;\n  }\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `ActionsButton-module__font-s-10___IA9eJ`,
	"fontS12": `ActionsButton-module__font-s-12___Y_6K3`,
	"fontS13": `ActionsButton-module__font-s-13___xCJCc`,
	"fontS14": `ActionsButton-module__font-s-14___wlM8E`,
	"fontS15": `ActionsButton-module__font-s-15___BPvvq`,
	"fontS16": `ActionsButton-module__font-s-16___gdMWH`,
	"fontS18": `ActionsButton-module__font-s-18___hHdZu`,
	"fontS20": `ActionsButton-module__font-s-20___OLEZs`,
	"fontS22": `ActionsButton-module__font-s-22___e05Ix`,
	"fontS28": `ActionsButton-module__font-s-28___peiDT`,
	"fontW400": `ActionsButton-module__font-w-400___xzi77`,
	"fontW500": `ActionsButton-module__font-w-500___UsCtb`,
	"fontW600": `ActionsButton-module__font-w-600___rai7t`,
	"fontW700": `ActionsButton-module__font-w-700___i2qhc`,
	"p5": `ActionsButton-module__p-5___yVgam`,
	"p12": `ActionsButton-module__p-12___BXqXG`,
	"p16": `ActionsButton-module__p-16___z9jFQ`,
	"p30": `ActionsButton-module__p-30___EpdwB`,
	"pB0": `ActionsButton-module__p-b-0___Wpros`,
	"pB5": `ActionsButton-module__p-b-5___Mt7hX`,
	"pB10": `ActionsButton-module__p-b-10___ikWsV`,
	"pB12": `ActionsButton-module__p-b-12___liaKa`,
	"pB16": `ActionsButton-module__p-b-16___KQhjc`,
	"pB18": `ActionsButton-module__p-b-18____OebH`,
	"pB20": `ActionsButton-module__p-b-20___BK9Sq`,
	"pB25": `ActionsButton-module__p-b-25___CxuTl`,
	"pB30": `ActionsButton-module__p-b-30___OzX00`,
	"pB50": `ActionsButton-module__p-b-50___NT6jW`,
	"pT0": `ActionsButton-module__p-t-0___SVxHg`,
	"pT12": `ActionsButton-module__p-t-12___DojMc`,
	"pT16": `ActionsButton-module__p-t-16___nSwze`,
	"pT18": `ActionsButton-module__p-t-18___BD36c`,
	"pT20": `ActionsButton-module__p-t-20___c7lhA`,
	"pT30": `ActionsButton-module__p-t-30___OPGi7`,
	"pT40": `ActionsButton-module__p-t-40___c1l41`,
	"pT50": `ActionsButton-module__p-t-50___is_tv`,
	"pL20": `ActionsButton-module__p-l-20___nHYju`,
	"pL30": `ActionsButton-module__p-l-30___t3MHj`,
	"pL40": `ActionsButton-module__p-l-40___tWrxQ`,
	"pR16": `ActionsButton-module__p-r-16___Xa5Fy`,
	"pR20": `ActionsButton-module__p-r-20___bOcVS`,
	"pR30": `ActionsButton-module__p-r-30___Xde8r`,
	"pR50": `ActionsButton-module__p-r-50___xVCMu`,
	"pR60": `ActionsButton-module__p-r-60___qvdI0`,
	"mB1": `ActionsButton-module__m-b-1___zSj5m`,
	"mB2": `ActionsButton-module__m-b-2___ek55G`,
	"mB6": `ActionsButton-module__m-b-6___JJsfc`,
	"mB8": `ActionsButton-module__m-b-8___ggZdM`,
	"mB10": `ActionsButton-module__m-b-10___mnzpT`,
	"mB14": `ActionsButton-module__m-b-14___NwR4M`,
	"mB16": `ActionsButton-module__m-b-16___bjs3_`,
	"mB20": `ActionsButton-module__m-b-20___PwnRw`,
	"mB22": `ActionsButton-module__m-b-22___b_TPX`,
	"mB24": `ActionsButton-module__m-b-24___pgXDK`,
	"mB30": `ActionsButton-module__m-b-30___I4DU0`,
	"mB32": `ActionsButton-module__m-b-32___fxMvU`,
	"mB40": `ActionsButton-module__m-b-40___nHwPt`,
	"mT2": `ActionsButton-module__m-t-2___TFEYU`,
	"mT3": `ActionsButton-module__m-t-3___TMYbb`,
	"mT4": `ActionsButton-module__m-t-4___FupYI`,
	"mT5": `ActionsButton-module__m-t-5___K9Ujq`,
	"mT8": `ActionsButton-module__m-t-8___GXTrv`,
	"mT10": `ActionsButton-module__m-t-10___TFexh`,
	"mT15": `ActionsButton-module__m-t-15___kzkGK`,
	"mT16": `ActionsButton-module__m-t-16___MrewF`,
	"mT20": `ActionsButton-module__m-t-20___XFISa`,
	"mT22": `ActionsButton-module__m-t-22___OqKEp`,
	"mT30": `ActionsButton-module__m-t-30___gWz0U`,
	"mT32": `ActionsButton-module__m-t-32___u11EV`,
	"mLAuto": `ActionsButton-module__m-l-auto___TsjAV`,
	"mL4": `ActionsButton-module__m-l-4___WP0sd`,
	"mL5": `ActionsButton-module__m-l-5___vnN_F`,
	"mL6": `ActionsButton-module__m-l-6___Bz6HS`,
	"mL8": `ActionsButton-module__m-l-8___d2tp6`,
	"mL10": `ActionsButton-module__m-l-10___G1xnR`,
	"mL16": `ActionsButton-module__m-l-16___JhC_t`,
	"mL20": `ActionsButton-module__m-l-20___ucw01`,
	"mL24": `ActionsButton-module__m-l-24___Sm05S`,
	"mL30": `ActionsButton-module__m-l-30___wH4a9`,
	"mL35": `ActionsButton-module__m-l-35___ncdHN`,
	"mL40": `ActionsButton-module__m-l-40___wbKxD`,
	"mR8": `ActionsButton-module__m-r-8___lhf4B`,
	"mR10": `ActionsButton-module__m-r-10___pQdS6`,
	"mR16": `ActionsButton-module__m-r-16___IqIBa`,
	"mR20": `ActionsButton-module__m-r-20___evWhd`,
	"mR24": `ActionsButton-module__m-r-24___uvZtk`,
	"mR30": `ActionsButton-module__m-r-30___rspgd`,
	"mR40": `ActionsButton-module__m-r-40____0opc`,
	"borderR3": `ActionsButton-module__border-r-3___GCPnC`,
	"borderR4": `ActionsButton-module__border-r-4___leSze`,
	"borderR6": `ActionsButton-module__border-r-6___tR8cE`,
	"borderR10": `ActionsButton-module__border-r-10___mqRPD`,
	"borderR12": `ActionsButton-module__border-r-12___h5BBg`,
	"borderR16": `ActionsButton-module__border-r-16___CV5jL`,
	"borderR50": `ActionsButton-module__border-r-50___qCstG`,
	"primaryBorder": `ActionsButton-module__primary-border___U1zah`,
	"primaryBorderB": `ActionsButton-module__primary-border-b___B43t8`,
	"primaryBorderT": `ActionsButton-module__primary-border-t___l10aq`,
	"primaryBorderL": `ActionsButton-module__primary-border-l___LSTZY`,
	"primaryBorderR": `ActionsButton-module__primary-border-r___kc0NF`,
	"secondaryBorder": `ActionsButton-module__secondary-border___hXI0s`,
	"secondaryBorderB": `ActionsButton-module__secondary-border-b___rgff3`,
	"secondaryBorderT": `ActionsButton-module__secondary-border-t___aJOW8`,
	"secondaryBorderL": `ActionsButton-module__secondary-border-l___YMK2N`,
	"secondaryBorderR": `ActionsButton-module__secondary-border-r___CNQgb`,
	"gap0": `ActionsButton-module__gap-0___yax3x`,
	"gap2": `ActionsButton-module__gap-2___LLLyq`,
	"gap4": `ActionsButton-module__gap-4___r9DiI`,
	"gap5": `ActionsButton-module__gap-5___nt1Ku`,
	"gap6": `ActionsButton-module__gap-6___bSwTW`,
	"gap8": `ActionsButton-module__gap-8___eivzj`,
	"gap10": `ActionsButton-module__gap-10___V8v4D`,
	"gap12": `ActionsButton-module__gap-12___L6ZMS`,
	"gap14": `ActionsButton-module__gap-14___ceP4g`,
	"gap16": `ActionsButton-module__gap-16___eu7Yw`,
	"gap18": `ActionsButton-module__gap-18___rXyjx`,
	"gap20": `ActionsButton-module__gap-20___HQRHa`,
	"gap24": `ActionsButton-module__gap-24___Kfp4y`,
	"gap26": `ActionsButton-module__gap-26___HE_cO`,
	"gap30": `ActionsButton-module__gap-30___Venb_`,
	"gap32": `ActionsButton-module__gap-32___S3xH_`,
	"gap40": `ActionsButton-module__gap-40___uBI9u`,
	"gap50": `ActionsButton-module__gap-50___rICQQ`,
	"flex1": `ActionsButton-module__flex-1___n_k2I`,
	"flexNone": `ActionsButton-module__flex-none____GFVo`,
	"flexColumn": `ActionsButton-module__flex-column___Fh22G`,
	"flexRow": `ActionsButton-module__flex-row___GYHgp`,
	"verticallyCentered": `ActionsButton-module__vertically-centered___eNbZ1`,
	"horizontallyCentered": `ActionsButton-module__horizontally-centered___wB7p3`,
	"horizontallyEnd": `ActionsButton-module__horizontally-end___Bodt8`,
	"verticallyStart": `ActionsButton-module__vertically-start___MEXii`,
	"spaceBetween": `ActionsButton-module__space-between___XfzPT`,
	"flexWrap": `ActionsButton-module__flex-wrap___LiasK`,
	"height100": `ActionsButton-module__height-100___sZaeP`,
	"width50": `ActionsButton-module__width-50___PNWT0`,
	"width100": `ActionsButton-module__width-100___X0SoN`,
	"cursorPointer": `ActionsButton-module__cursor-pointer___oBmyT`,
	"cursorNotAllowed": `ActionsButton-module__cursor-not-allowed___yzT0S`,
	"absoluteCentered": `ActionsButton-module__absolute-centered___G_1xD`,
	"absolute": `ActionsButton-module__absolute___qB6dl`,
	"relative": `ActionsButton-module__relative___HLYFl`,
	"fixed": `ActionsButton-module__fixed___YLg2b`,
	"visible": `ActionsButton-module__visible___YUhyg`,
	"invisible": `ActionsButton-module__invisible___TnsM9`,
	"col90": `ActionsButton-module__col-90___rbJ1J`,
	"colAuto": `ActionsButton-module__col-auto___kmhJV`,
	"medicalTabs": `ActionsButton-module__medical-tabs___eJ9I5`,
	"medicalTableNew": `ActionsButton-module__medical-table-new___xsRTo`,
	"noPagination": `ActionsButton-module__no-pagination___jj6bR`,
	"medicalTableEmpty": `ActionsButton-module__medical-table-empty___sx9jU`,
	"iconBtn": `ActionsButton-module__icon-btn___VhtWl`,
	"searchIcon": `ActionsButton-module__search-icon___jD7aP`,
	"disableSelect": `ActionsButton-module__disable-select___CJrCi`,
	"breakWord": `ActionsButton-module__break-word___VvQL1`,
	"popupClearBtn": `ActionsButton-module__popup-clear-btn___GN1zr`,
	"scrollMB20": `ActionsButton-module__scroll-m-b-20___TTai9`,
	"button": `ActionsButton-module__button___weqaq`,
	"menu": `ActionsButton-module__menu___uwy1l`
};
module.exports = ___CSS_LOADER_EXPORT___;
